/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _modules_functions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/functions.js */ \"./src/js/modules/functions.js\");\n/* harmony import */ var _modules_global_menu_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/global/menu.js */ \"./src/js/modules/global/menu.js\");\n\n\n// import * as Faq from \"./modules/pages/faq.js\";\n// import * as Animate from \"./modules/pages/_animate.js\";\n\n\n'use strict';\nwindow.addEventListener('load', () => {\n    _modules_functions_js__WEBPACK_IMPORTED_MODULE_0__.isWebp();\n    _modules_global_menu_js__WEBPACK_IMPORTED_MODULE_1__.menu();\n    // Menu.popUp();\n    // Menu.search();\n    // if(document.querySelector('.page-faq') != undefined) {\n        // Faq.faq();\n    // }\n\n})\n\n\n//# sourceURL=webpack:///./src/js/app.js?");

/***/ }),

/***/ "./src/js/modules/functions.js":
/*!*************************************!*\
  !*** ./src/js/modules/functions.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   isWebp: () => (/* binding */ isWebp)\n/* harmony export */ });\nfunction isWebp() {\n\n    function testWebP(callback) {\n\n        let webP = new Image();\n        webP.onload = webP.onerror = function () {\n        callback(webP.height == 2);\n        };\n        webP.src = \"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA\";\n        }\n        \n        testWebP(function (support) {\n        \n        if (support == true) {\n        document.querySelector('body').classList.add('webp');\n        }else{\n        document.querySelector('body').classList.add('no-webp');\n        }\n        });\n}\n\n//# sourceURL=webpack:///./src/js/modules/functions.js?");

/***/ }),

/***/ "./src/js/modules/global/menu.js":
/*!***************************************!*\
  !*** ./src/js/modules/global/menu.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   menu: () => (/* binding */ menu)\n/* harmony export */ });\nfunction menu() {\n  let burger = document.querySelector(\".burger\");\n  let menu = document.querySelector(\".mobile__menu\");\n  let body = document.querySelector(\"body\");\n  let header = document.querySelector(\".header-mobile__inner\");\n\n  let mobileLinks = document.querySelectorAll(\".mobile__menu-link\");\n  let mobileSubmenuLinks = document.querySelectorAll(\".sub-menu__link\");\n  let mobileBackLink = document.querySelectorAll('.sub-menu__back');\n\n  mobileLinks.forEach((el) => {\n    if (el.nextElementSibling) {\n      el.addEventListener(\"click\", () => {\n        el.nextElementSibling.classList.add(\"active\");\n      });\n    }\n  });\n  mobileBackLink.forEach(el => {\n    el.addEventListener('click', ()=> {\n      el.closest('.sub-menu').classList.remove('active');\n    })\n  });\n\n  burger.addEventListener(\"click\", (e) => {\n    menu.classList.toggle(\"active\");\n    burger.classList.toggle(\"active\");\n    body.classList.toggle(\"block\");\n    header.classList.toggle(\"active\");\n  });\n\n  mobileSubmenuLinks.forEach(el => {\n    el.addEventListener('click', () => {\n      menu.classList.remove(\"active\");\n      burger.classList.remove(\"active\");\n      body.classList.remove(\"block\");\n      header.classList.remove(\"active\");\n      el.closest('.sub-menu').classList.remove('active');\n\n    })\n  })\n}\n\n\n//# sourceURL=webpack:///./src/js/modules/global/menu.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/app.js");
/******/ 	
/******/ })()
;